import {FormSection} from "../../../ui";
import {FulfilmentMaximumVehiclesPerDeliveryMethodDto} from "../../../../api/cms";
import {FieldInput} from "@kroschke/react-ui";


interface CmsFulfillmentConfigurationFormData {
    fulfilmentMaximumVehiclesPerDeliveryMethod: FulfilmentMaximumVehiclesPerDeliveryMethodDto
}

export interface CmsFulfillmentConfigurationFormHelp {
    lateMorning?: string,
    morning?: string,
    noon?: string,
    post?: string,
    tracked?: string,
}

interface CmsFulfillmentConfigurationFormProps {
    value: CmsFulfillmentConfigurationFormData
    onChange: (value: CmsFulfillmentConfigurationFormData) => any
    validate: () => Promise<any>
    saving: boolean
    help: CmsFulfillmentConfigurationFormHelp
}


const CmsFulfillmentConfigurationForm = function CmsFulfillmentConfigurationForm({
                                                                                     value,
                                                                                     saving,
                                                                                     onChange,
                                                                                     validate,
                                                                                     help
                                                                                 }: CmsFulfillmentConfigurationFormProps) {
    return <FormSection
        label={"Maximale Anzahl Fahrzeuge pro Versandpaket und Versandart"}>
        <>
            <div className={"columns"}>
                <div className={"column is-one-third"}>
                    <FieldInput
                        label={"bis 9:00 Uhr"}
                        disabled={saving}
                        help={help.morning}
                        invalid={Boolean(help.morning)}
                        value={value.fulfilmentMaximumVehiclesPerDeliveryMethod.morning?.toString() || ''}
                        onBlur={async () => await validate()}
                        onChange={morning => {
                            onChange({
                                ...value,
                                fulfilmentMaximumVehiclesPerDeliveryMethod: {
                                    ...value.fulfilmentMaximumVehiclesPerDeliveryMethod,
                                    morning: parseInt(morning) || undefined,
                                }
                            })
                        }}
                    />
                </div>
                <div className={"column is-one-third"}>
                    <FieldInput
                        label={"bis 10:30 Uhr"}
                        disabled={saving}
                        help={help.lateMorning}
                        invalid={Boolean(help.lateMorning)}
                        value={value.fulfilmentMaximumVehiclesPerDeliveryMethod.lateMorning?.toString() || ''}
                        onBlur={async () => await validate()}
                        onChange={lateMorning => {
                            onChange({
                                ...value,
                                fulfilmentMaximumVehiclesPerDeliveryMethod: {
                                    ...value.fulfilmentMaximumVehiclesPerDeliveryMethod,
                                    lateMorning: parseInt(lateMorning) || undefined,
                                }
                            })
                        }}
                    />
                </div>
                <div className={"column is-one-third"}>
                    <FieldInput
                        label={"bis 12:00 Uhr"}
                        disabled={saving}
                        help={help.noon}
                        invalid={Boolean(help.noon)}
                        value={value.fulfilmentMaximumVehiclesPerDeliveryMethod.noon?.toString() || ''}
                        onBlur={async () => await validate()}
                        onChange={noon => {
                            onChange({
                                ...value,
                                fulfilmentMaximumVehiclesPerDeliveryMethod: {
                                    ...value.fulfilmentMaximumVehiclesPerDeliveryMethod,
                                    noon: parseInt(noon) || undefined,
                                }
                            })
                        }}
                    />
                </div>
            </div>
            <div className={"columns"}>
                <div className={"column is-one-third"}>
                    <FieldInput
                        label={"Post"}
                        disabled={saving}
                        help={help.post}
                        invalid={Boolean(help.post)}
                        value={value.fulfilmentMaximumVehiclesPerDeliveryMethod.post?.toString() || ''}
                        onBlur={async () => await validate()}
                        onChange={post => {
                            onChange({
                                ...value,
                                fulfilmentMaximumVehiclesPerDeliveryMethod: {
                                    ...value.fulfilmentMaximumVehiclesPerDeliveryMethod,
                                    post: parseInt(post) || undefined,
                                }
                            })
                        }}
                    />
                </div>
                <div className={"column is-one-third"}>
                    <FieldInput
                        label={"Sendungsverfolgt"}
                        disabled={saving}
                        help={help.tracked}
                        invalid={Boolean(help.tracked)}
                        value={value.fulfilmentMaximumVehiclesPerDeliveryMethod.tracked?.toString() || ''}
                        onBlur={async () => await validate()}
                        onChange={tracked => {
                            onChange({
                                ...value,
                                fulfilmentMaximumVehiclesPerDeliveryMethod: {
                                    ...value.fulfilmentMaximumVehiclesPerDeliveryMethod,
                                    tracked: parseInt(tracked) || undefined,
                                }
                            })
                        }}
                    />
                </div>
            </div>
        </>
    </FormSection>
}

export {
    CmsFulfillmentConfigurationForm,
}
